export default __webpack_public_path__ + "static/media/money-bag-white.1e656f32.svg";